import type React from 'react'

interface CloseCropIconProps {
  size?: number | string
  color?: string
  className?: string
}

const CloseCropIcon: React.FC<CloseCropIconProps> = ({ size = 24, color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={'Close Crop Icon'}
      role="img"
    >
      <path
        opacity="0.4"
        d="M15.491 3.66602H8.50768C5.47435 3.66602 3.66602 5.47435 3.66602 8.50768V15.4827C3.66602 18.5244 5.47435 20.3327 8.50768 20.3327H15.4827C18.516 20.3327 20.3243 18.5244 20.3243 15.491V8.50768C20.3327 5.47435 18.5243 3.66602 15.491 3.66602Z"
        fill={color}
      />
      <path
        d="M12.8841 12.0008L14.8008 10.0841C15.0424 9.84245 15.0424 9.44245 14.8008 9.20078C14.5591 8.95911 14.1591 8.95911 13.9174 9.20078L12.0008 11.1174L10.0841 9.20078C9.84245 8.95911 9.44245 8.95911 9.20078 9.20078C8.95911 9.44245 8.95911 9.84245 9.20078 10.0841L11.1174 12.0008L9.20078 13.9174C8.95911 14.1591 8.95911 14.5591 9.20078 14.8008C9.32578 14.9258 9.48411 14.9841 9.64245 14.9841C9.80078 14.9841 9.95911 14.9258 10.0841 14.8008L12.0008 12.8841L13.9174 14.8008C14.0424 14.9258 14.2008 14.9841 14.3591 14.9841C14.5174 14.9841 14.6758 14.9258 14.8008 14.8008C15.0424 14.5591 15.0424 14.1591 14.8008 13.9174L12.8841 12.0008Z"
        fill={color}
      />
    </svg>
  )
}

export default CloseCropIcon
